import { ApiUrls } from '@/service/constants/urls';
import { TDelCartApiParams } from '@/domain/Cart.domain';
import { instance } from '../Axios';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const delCartApi = async ({ id, item_id, partnerId }: TDelCartApiParams): Promise<void> =>
    instance.post(`${ApiUrls.cart.del}/${id}/${item_id}?partnerId=${replaceLightframe(partnerId)}`);
